import React from 'react'
import ReactDOM from 'react-dom'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './index.css'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
